let drawerDisplayState: 'visible' | 'hidden' = 'hidden';
const listeners = new Set<() => void>();

/**
 * External store used by `usePlayerSessionCard` to reset per-card UI state (step view mode)
 * whenever the underlying list query result changes (search, filter, sort, pagination).
 */
export const drawerStateStore = {
  subscribe(callback: () => void) {
    listeners.add(callback);
    return () => {
      listeners.delete(callback);
    };
  },
  getSnapshot() {
    return drawerDisplayState;
  },
  setDisplayState(state: 'visible' | 'hidden') {
    drawerDisplayState = state;
    listeners.forEach(listener => listener());
  },
};
